document.addEventListener("DOMContentLoaded", function () {
  // 动态获取卡片宽度
  function getCardWidth(list) {
    const card = list.querySelector(".product-item");
    return card ? card.getBoundingClientRect().width : 0;
  }
  // 动态获取每页可见卡片数
  function getPerPage(list) {
    const listRect = list.getBoundingClientRect();
    const style = getComputedStyle(list);
    const paddingLeft = parseFloat(style.paddingLeft);
    const paddingRight = parseFloat(style.paddingRight);
    const cardWidth = getCardWidth(list);
    if (!cardWidth) return 1;
    return Math.floor(
      (listRect.width - paddingLeft - paddingRight) / cardWidth
    );
  }

  // 产品列表渲染
  function renderProductLists() {
    document.querySelectorAll(".dropdown-layout-1").forEach((tabPlane) => {
      const list = tabPlane.querySelector(".dropdown-product-list");
      if (!list) return;
      const cards = list.querySelectorAll(".product-item");
      const count = cards.length;
      const isMobile =
        window.innerWidth < 768 || document.documentElement.clientWidth < 768;
      if (isMobile) {
        // 先移除
        list.classList.remove("container");
        list.classList.remove("scrollable");
        list.classList.remove("scrollbarHide");
        list.classList.add("mobileGrid");
      } else {
        // PC端按原有逻辑
        if (count <= 6) {
          tabPlane
            .querySelectorAll(".header-list-arrows")
            .forEach((el) => el.remove());
          list.classList.remove("scrollable");
          list.classList.add("grid");
          list.classList.add("container");
        } else if (count > 6) {
          {
            list.classList.add("scrollable");
            list.classList.add("scrollbarHide");
            list._currentIndex = 0;

            // 先移除已有的箭头，保证只存在一个
            tabPlane
              .querySelectorAll(".header-list-arrows")
              .forEach((el) => el.remove());

            // 箭头按钮
            const arrows = document.createElement("div");
            arrows.className = "header-list-arrows container";
            const leftBtn = document.createElement("button");
            leftBtn.className = "header-list-arrow";
            leftBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/>
</svg>
`;
            leftBtn.disabled = true;
            const rightBtn = document.createElement("button");
            rightBtn.className = "header-list-arrow";
            rightBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/>
</svg>
`;
            arrows.appendChild(leftBtn);
            arrows.appendChild(rightBtn);
            tabPlane.appendChild(arrows);

            function updateCards() {
              const currentIndex = list._currentIndex || 0;
              const perPage = getPerPage(list);
              const cardWidth = getCardWidth(list);
              const maxIndex = Math.max(0, count - perPage);
              const centerStart = currentIndex;
              const centerEnd = centerStart + perPage;
              cards.forEach((card, idx) => {
                if (idx >= centerStart && idx < centerEnd) {
                  card.classList.remove("outside");
                } else {
                  card.classList.add("outside");
                }
              });
              leftBtn.disabled = currentIndex === 0;
              rightBtn.disabled = currentIndex >= maxIndex;
              // 按钮内容控制
              // leftBtn.innerHTML = leftBtn.disabled ? "<" : "<";
              // rightBtn.innerHTML = rightBtn.disabled ? "<" : ">";
              if (currentIndex >= maxIndex) {
                list.classList.add("at-end");
              } else {
                list.classList.remove("at-end");
              }
            }
            // 让外部可调用
            list._updateCards = updateCards;

            function scrollToIndex(idx) {
              const perPage = getPerPage(list);
              const cardWidth = getCardWidth(list);
              const maxIndex = Math.max(0, count - perPage);
              let targetIdx = Math.min(idx, maxIndex);
              list._currentIndex = targetIdx;
              const scrollLeft = targetIdx * cardWidth;
              list.scrollTo({ left: scrollLeft, behavior: "smooth" });
              updateCards();
            }

            leftBtn.addEventListener("click", function () {
              const perPage = getPerPage(list);
              if ((list._currentIndex || 0) > 0)
                scrollToIndex((list._currentIndex || 0) - 1);
            });
            rightBtn.addEventListener("click", function () {
              const perPage = getPerPage(list);
              if ((list._currentIndex || 0) < Math.max(0, count - perPage))
                scrollToIndex((list._currentIndex || 0) + 1);
            });

            // hover效果：鼠标移入透明卡片时，透明度100%且放大
            cards.forEach((card) => {
              card.addEventListener("mouseenter", function () {
                if (card.classList.contains("outside")) {
                  card.style.opacity = "1";
                  card.style.zIndex = "2";
                }
              });
              card.addEventListener("mouseleave", function () {
                if (card.classList.contains("outside")) {
                  card.style.opacity = "";
                  card.style.transform = "";
                  card.style.zIndex = "";
                }
              });
            });

            // 新增：监听滚动事件，实时更新按钮和卡片状态
            list.addEventListener("scroll", function () {
              const cardWidth = getCardWidth(list);
              if (!cardWidth) return;
              const newIndex = Math.round(list.scrollLeft / cardWidth);
              if (list._currentIndex !== newIndex) {
                list._currentIndex = newIndex;
                if (typeof list._updateCards === "function") {
                  list._updateCards();
                }
              }
            });

            // 初始化
            updateCards();
            setTimeout(updateCards, 50);
            // 图片加载后再刷新一次
            const img = list.querySelector("img");
            if (img) {
              img.addEventListener("load", function () {
                updateCards();
              });
            }
          }
        }
      }
    });
  }

  // 动态设置滚动区两侧padding，保证内容居中且最大宽度不超过1200px
  function setProductListSidePadding() {
    const maxContentWidth = 1200;
    const winWidth = window.innerWidth;
    let sidePadding = (winWidth - Math.min(winWidth, maxContentWidth)) / 2;
    if (sidePadding < 40) sidePadding = 80;
    document
      .querySelectorAll(".dropdown-product-list.scrollable")
      .forEach((list) => {
        list.style.setProperty(
          "--header-list-side-padding",
          sidePadding + "px"
        );
      });
  }

  window.addEventListener("DOMContentLoaded", () => {
    renderProductLists();
    setProductListSidePadding();
  });
  window.addEventListener("resize", setProductListSidePadding);
  window.addEventListener("resize", renderProductLists);

  // 全局刷新：页面load和resize时刷新所有滚动区
  window.addEventListener("load", function () {
    document
      .querySelectorAll(".dropdown-product-list.scrollable")
      .forEach((list) => {
        if (typeof list._updateCards === "function") list._updateCards();
      });
  });
  window.addEventListener("resize", function () {
    document
      .querySelectorAll(".dropdown-product-list.scrollable")
      .forEach((list) => {
        if (typeof list._updateCards === "function") list._updateCards();
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".dropdown-layout-2").forEach(function (layout) {
    const leftLinks = layout.querySelectorAll(".nav-left a[data-id]");
    const wraps = layout.querySelectorAll(".nav-right-list-wrap");

    // 默认高亮第一个
    if (leftLinks.length > 0) {
      leftLinks[0].classList.add("active");
      wraps.forEach((wrap) => (wrap.style.display = "none"));
      const firstId = leftLinks[0].getAttribute("data-id");
      const firstRight = layout.querySelector(
        '.nav-right-list[data-id="' + firstId + '"]'
      );
      if (firstRight) {
        const firstWrap = firstRight.parentNode;
        firstWrap.style.display = "block";
        setupNavRightListScroll(firstWrap);
      }
    }

    leftLinks.forEach((link) => {
      link.addEventListener("mouseenter", function (e) {
        // 移除所有高亮
        leftLinks.forEach((l) => l.classList.remove("active"));
        // 当前高亮
        this.classList.add("active");
        // 隐藏所有右侧
        wraps.forEach((wrap) => (wrap.style.display = "none"));
        // 显示对应的右侧
        const id = this.getAttribute("data-id");
        const right = layout.querySelector(
          '.nav-right-list[data-id="' + id + '"]'
        );
        if (right) {
          const wrap = right.parentNode;
          wrap.style.display = "block";
          // 重置滚动条和状态
          const navRightList = wrap.querySelector(".nav-right-list");
          if (navRightList) {
            navRightList.scrollLeft = 0;
            if (typeof navRightList._currentIndex !== "undefined")
              navRightList._currentIndex = 0;
            if (typeof navRightList._updateCards === "function")
              navRightList._updateCards();
          }
          setupNavRightListScroll(wrap);
          // 新增：菜单显示后强制刷新横滑区，保证宽度变化后显示正常
          refreshVisibleHorizontalScroll(wrap);
        }
      });
    });
  });

  // 横向滚动、按钮和 outside 功能（修正版）
  function setupNavRightListScroll(wrap) {
    const list = wrap.querySelector(".nav-right-list");
    if (!list) return;
    // 防止重复插入按钮
    if (wrap.querySelector(".header-list-arrows")) return;
    const cards = list.querySelectorAll(".product-item");
    const count = cards.length;
    if (count <= 6) return;

    // 创建按钮容器
    const arrows = document.createElement("div");
    arrows.className = "header-list-arrows";
    const leftBtn = document.createElement("button");
    leftBtn.className = "header-list-arrow";
    leftBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.8947 0C5.2851 0.390998 5.2851 1.02493 4.8947 1.41593L1.3161 5L4.8947 8.58407C5.2851 8.97507 5.2851 9.609 4.8947 10L0.255775 5.35398C0.0605749 5.15848 0.0605749 4.84152 0.255775 4.64602L4.8947 0Z" fill="black"/>
</svg>
`;
    leftBtn.disabled = true;
    const rightBtn = document.createElement("button");
    rightBtn.className = "header-list-arrow";
    rightBtn.innerHTML = `
<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.1053 10C0.7149 9.609 0.7149 8.97507 1.1053 8.58407L4.6839 5L1.1053 1.41593C0.7149 1.02493 0.7149 0.390998 1.1053 0L5.74422 4.64602C5.93943 4.84152 5.93943 5.15848 5.74422 5.35398L1.1053 10Z" fill="black"/>
</svg>
`;
    arrows.appendChild(leftBtn);
    arrows.appendChild(rightBtn);

    // 插入按钮到列表后面
    wrap.appendChild(arrows);

    // 滚动和 outside 逻辑
    function getCardWidth() {
      // 取第一个可见卡片
      const card = Array.from(list.querySelectorAll(".product-item")).find(
        (el) => el.offsetParent !== null
      );
      return card ? card.getBoundingClientRect().width : 1;
    }
    function getPerPage() {
      const listRect = list.getBoundingClientRect();
      const style = getComputedStyle(list);
      const paddingLeft = parseFloat(style.paddingLeft);
      const paddingRight = parseFloat(style.paddingRight);
      const cardWidth = getCardWidth();
      if (!cardWidth || cardWidth < 1) return 1;
      return Math.max(
        1,
        Math.floor((listRect.width - paddingLeft - paddingRight) / cardWidth)
      );
    }
    function updateCardsAndArrows() {
      const cardWidth = getCardWidth();
      const perPage = getPerPage();
      const cards = list.querySelectorAll(".product-item");
      const count = cards.length;
      const maxIndex = Math.max(0, count - perPage);
      // floor 保证 currentIndex 不会超出
      const currentIndex = Math.floor(list.scrollLeft / cardWidth);

      // outside 逻辑
      const centerStart = currentIndex;
      const centerEnd = centerStart + perPage;
      cards.forEach((card, idx) => {
        if (idx >= centerStart && idx < centerEnd) {
          card.classList.remove("outside");
        } else {
          card.classList.add("outside");
        }
      });

      // 按钮逻辑
      leftBtn.disabled = currentIndex <= 0;
      rightBtn.disabled = currentIndex >= maxIndex;
    }
    let throttleTimer = null;
    const throttleDelay = 400; // 和动画时长一致
    leftBtn.addEventListener("click", function () {
      if (throttleTimer) return;
      const cardWidth = getCardWidth();
      list.scrollBy({ left: -cardWidth, behavior: "smooth" });
      throttleTimer = setTimeout(() => {
        throttleTimer = null;
      }, throttleDelay);
    });
    rightBtn.addEventListener("click", function () {
      if (throttleTimer) return;
      const cardWidth = getCardWidth();
      list.scrollBy({ left: cardWidth, behavior: "smooth" });
      throttleTimer = setTimeout(() => {
        throttleTimer = null;
      }, throttleDelay);
    });
    list.addEventListener("scroll", updateCardsAndArrows);
    window.addEventListener("resize", updateCardsAndArrows);
    updateCardsAndArrows();
    setTimeout(updateCardsAndArrows, 100);
    // 图片加载后再刷新一次
    const img = list.querySelector("img");
    if (img) {
      img.addEventListener("load", function () {
        updateCardsAndArrows();
      });
    }
  }

  // 动态设置 .dropdown-layout-2.container-center 的左右padding，保证居中且最大宽度1200px
  function setDropdownLayout2SidePadding() {
    const maxContentWidth = 1200;
    const winWidth = window.innerWidth;
    let sidePadding = (winWidth - Math.min(winWidth, maxContentWidth)) / 2;
    if (sidePadding < 40) sidePadding = 40;
    document.querySelectorAll(".dropdown-layout-2").forEach((el) => {
      el.style.setProperty("--dropdown-side-padding", sidePadding + "px");
    });
  }
  window.addEventListener("DOMContentLoaded", setDropdownLayout2SidePadding);
  window.addEventListener("resize", setDropdownLayout2SidePadding);
});

// collapse-layout-2 手风琴折叠交互（支持每个category-item内部结构）

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collapse-layout-2").forEach(function (layout) {
    const items = layout.querySelectorAll(".category-item");
    // 默认展开第一个
    // if (items.length > 0) {
    //   const firstToggle = items[0].querySelector(
    //     ".category-title.collapse-toggle"
    //   );
    //   const firstContent = items[0].querySelector(".collapse-content");
    //   if (firstToggle && firstContent) {
    //     firstContent.classList.add("expanded");
    //     firstToggle.classList.add("expanded");
    //   }
    // }
    items.forEach(function (item) {
      const toggle = item.querySelector(".category-title.collapse-toggle");
      const content = item.querySelector(".collapse-content");
      if (toggle && content) {
        toggle.addEventListener("click", function () {
          // 先收起所有
          /*
          layout
            .querySelectorAll(".collapse-content")
            .forEach(function (otherContent) {
              if (otherContent !== content) {
                otherContent.classList.remove("expanded");
                const otherToggle = otherContent.parentNode.querySelector(
                  ".category-title.collapse-toggle"
                );
                if (otherToggle) otherToggle.classList.remove("expanded");
              }
            });
          */
          // 切换当前
          content.classList.toggle("expanded");
          toggle.classList.toggle("expanded");
        });
      }
    });
  });
});

function resetDropdownLayout2() {
  document.querySelectorAll(".dropdown-layout-2").forEach(function (layout) {
    const leftLinks = layout.querySelectorAll(".nav-left a[data-id]");
    const wraps = layout.querySelectorAll(".nav-right-list-wrap");
    // 高亮第一个
    leftLinks.forEach((l, i) => l.classList.toggle("active", i === 0));
    // 隐藏所有右侧，只显示第一个
    wraps.forEach(
      (wrap, i) => (wrap.style.display = i === 0 ? "block" : "none")
    );
    // 所有右侧横滑区域 scrollLeft 归零
    wraps.forEach((wrap) => {
      const navRightList = wrap.querySelector(".nav-right-list");
      if (navRightList) {
        navRightList.scrollLeft = 0;
        if (typeof navRightList._currentIndex !== "undefined")
          navRightList._currentIndex = 0;
        if (typeof navRightList._updateCards === "function")
          navRightList._updateCards();
      }
    });
  });
}

function resetCollapseLayout1() {
  document.querySelectorAll(".collapse-layout-1").forEach(function (layout) {
    const items = layout.querySelectorAll(".category-item");
    items.forEach((item, i) => {
      const toggle = item.querySelector(".category-title.collapse-toggle");
      const content = item.querySelector(".collapse-content");
      if (toggle && content) {
        if (i === 0) {
          content.classList.add("expanded");
          toggle.classList.add("expanded");
        } else {
          content.classList.remove("expanded");
          toggle.classList.remove("expanded");
        }
      }
    });
  });
}

function resetAllHorizontalScroll() {
  document
    .querySelectorAll(
      ".dropdown-product-list, .nav-right-list, .product-list.scrollable"
    )
    .forEach((list) => {
      list.scrollLeft = 0;
      if (typeof list._currentIndex !== "undefined") list._currentIndex = 0;
      if (typeof list._updateCards === "function") list._updateCards();
    });
}

function refreshVisibleHorizontalScroll(container) {
  container
    .querySelectorAll(
      ".nav-right-list, .dropdown-product-list, .product-list.scrollable"
    )
    .forEach((list) => {
      if (typeof list._updateCards === "function") list._updateCards();
    });
}

window.addEventListener("resize", function () {
  resetDropdownLayout2();
  resetCollapseLayout1();
  resetAllHorizontalScroll();
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".site-header .ant-item").forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      item.classList.add("active");
    });
    item.addEventListener("mouseleave", function () {
      item.classList.remove("active");
    });
  });
});

// collapse-menu-wrapper 折叠交互（手风琴效果，默认展开第一个）
document.addEventListener("DOMContentLoaded", function () {
  function renderMemu() {
    // 先解绑所有事件，移除 expanded
    document
      .querySelectorAll(".collapse-menu-wrapper")
      .forEach(function (wrapper) {
        wrapper.classList.remove("expanded");
        const menu = wrapper.querySelector(".collapse-menu");
        if (menu) menu.style.display = "none";
        // 解绑事件（可选，防止重复绑定）
        const arrow = wrapper.querySelector(".menu-collapse-arrow");
        if (arrow) {
          const newArrow = arrow.cloneNode(true);
          arrow.parentNode.replaceChild(newArrow, arrow);
        }
      });

    if (window.innerWidth > 1200 || document.documentElement.clientWidth > 1200)
      return;
    // 点击一级菜单展开/收起
    document
      .querySelectorAll(".collapse-menu-wrapper  .menu-collapse-arrow")
      .forEach(function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          // 当前 wrapper
          const wrapper = link.closest(".collapse-menu-wrapper");
          // 当前 collapse-menu
          const menu = wrapper.querySelector(".collapse-menu");
          // 其它 wrapper
          /*
          document
            .querySelectorAll(".collapse-menu-wrapper")
            .forEach(function (otherWrapper) {
              if (otherWrapper !== wrapper) {
                otherWrapper.classList.remove("expanded");
                const otherMenu = otherWrapper.querySelector(".collapse-menu");
                if (otherMenu) otherMenu.style.display = "none";
              }
            });
          */
          // 切换当前
          const isExpanded = wrapper.classList.toggle("expanded");
          if (menu) menu.style.display = isExpanded ? "block" : "none";
        });
      });
    // 页面加载时只展开第一个
    document
      .querySelectorAll(".collapse-menu-wrapper")
      .forEach(function (wrapper, i) {
        const menu = wrapper.querySelector(".collapse-menu");
        if (menu) {
          if (i === 0) {
            wrapper.classList.add("expanded");
            menu.style.display = "block";
          } else {
            wrapper.classList.remove("expanded");
            menu.style.display = "none";
          }
        }
      });
  }
  renderMemu();
  window.addEventListener("resize", renderMemu);
});

// 移动端点击一级下拉菜单（有子链接的 ant-item dropdown）展开/收起
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".site-header li.ant-item.dropdown .menu-collapse-arrow")
    .forEach(function (arrow) {
      arrow.addEventListener("click", function (e) {
        e.preventDefault();
        if (
          window.innerWidth > 1200 ||
          document.documentElement.clientWidth > 1200
        )
          return;
        const item = arrow.closest(".ant-item.dropdown");
        if (item) item.classList.toggle("expanded");
      });
    });
});
